import { storeToRefs } from 'pinia';
import type { Ref } from 'vue';
import { computed, ref } from 'vue';
import { assignArray } from '@/core/lib/array';
import businessLogicHelper from '@/core/lib/businessLogicHelper';
import { deepFreeze } from '@/core/lib/utils';
import { formatStreamEvent } from '@/core/oddsApi/helpers/formatStreamEvents';
import { useStreamEventsQuery } from '@/core/oddsApi/oddsApiType';
import type { IStreamEvent } from '@/interface/IStream';
import { useOddsApiStore } from '@/store/oddsApiStore';

export function useStreamEvents(isEnabled: Ref<boolean> = ref(true)) {
    const { loaded, loading, onResult, refetch: refetchStreamEvents } = useStreamEventsQuery(
        {},
        computed(() => ({

            enabled: isEnabled.value,
        })),
    );

    const { customerSettings, additionalSettings } = storeToRefs(useOddsApiStore());

    const streamEvents = ref<IStreamEvent[]>([]);
    onResult((result) => {
        const newStreamEvents = (result ?? [])
            .filter(event => businessLogicHelper.isEventAllowed(customerSettings.value, event, additionalSettings.value))
            .map(event => deepFreeze(formatStreamEvent(event)));

        assignArray(streamEvents.value, newStreamEvents, x => x.eventId);
    });

    return {
        loaded,
        loading,
        streamEvents,
        refetchStreamEvents,
    };
}
